import {
  getRequest,
  postRequest,
  patchRequest,
  deleteRequest,
} from "../../common/network-call";
import { INSTANCE_URL, itemCount } from "../../common/constant";
import _ from "lodash";

export const PACKAGE_LIST = "PACKAGE_LIST";
export const TOKEN_LIST = "TOKEN_LIST";
export const RECHARGE_MODAL = "RECHARGE_MODAL";
export const PURCHASE_MODAL = "PURCHASE_MODAL";
export const PURCHASE_TRANSACTION_LIST = "PURCHASE_TRANSACTION_LIST";
export const USER_BALANCE = "USER_BALANCE";
export const CONVERSION_RATE = "CONVERSION_RATE";

export function fetchConversionRate(session, userid, callback) {
  var url = `${INSTANCE_URL}api/v2/tikwash/_table/appuser?fields=tokenamount&filter=(userid=${userid})`;
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        dispatch({
          type: CONVERSION_RATE,
          payload: { data: response.resource },
        });
        callback({ success: 1 });
      },
      (error) => {
        // callback({success: 0, error: error});
      }
    );
  };
}

export function fetchBalance(session, companyid, callback) {
  var url = `${INSTANCE_URL}api/v2/tikwash/_table/appuser_token?filter=((useridfk=${session.userid})AND(companyidfk=${companyid}))`;
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        dispatch({
          type: USER_BALANCE,
          payload: { data: response.resource },
        });
        callback({ success: 1 });
      },
      (error) => {
        // callback({success: 0, error: error});
      }
    );
  };
}

export function fetchPackage(session, companyid, pageCount = 0, callback) {
  var perPage = itemCount;
  var offset = pageCount <= 1 ? 0 : (pageCount - 1) * perPage;
  var offSetQuery = `&limit=${perPage}&offset=${offset}`;

  var url = `${INSTANCE_URL}api/v2/tikwash/_table/token_package?include_count=true&filter=((useridfk=${companyid})AND(isactive=1))&order=tokencost%20DESC`;
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        dispatch({
          type: PACKAGE_LIST,
          payload: { data: response.resource, count: response.meta.count },
        });
        callback({ success: 1 });
      },
      (error) => {
        // callback({success: 0, error: error});
      }
    );
  };
}

export function fetchWalletList(session, pageCount = 0, callback) {
  var perPage = itemCount;
  var offset = pageCount <= 1 ? 0 : (pageCount - 1) * perPage;
  var offSetQuery = `&limit=${perPage}&offset=${offset}`;

  var url = `${INSTANCE_URL}api/v2/tikwash/_table/appuser_token?filter=((useridfk=${session.userid})AND(status=active))&related=*&include_count=true&order=companyidfk&%20DESC`;
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        dispatch({
          type: TOKEN_LIST,
          payload: { data: response.resource, count: response.meta.count },
        });
        callback({ success: 1 });
      },
      (error) => {
        // callback({success: 0, error: error});
      }
    );
  };
}

export function openRechargeModal(showModal) {
  return { type: RECHARGE_MODAL, payload: showModal };
}

export function addOrder(session, values, callback) {
  var urlVehicle = `${INSTANCE_URL}api/v2/app_services`;

  return (dispatch) => {
    postRequest(
      urlVehicle,
      values,
      session,
      dispatch,
      (response) => {
        //console.log("location response: -", response);
        if (
          response.resource &&
          response.resource.success &&
          response.resource.success > 0
        ) {
          callback({ success: 1 });
        } else {
          callback({ success: 0 });
        }
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function makePayment(session, payValues, callback) {
  var url = `${INSTANCE_URL}api/v2/idealpay`;

  return (dispatch) => {
    postRequest(
      url,
      payValues,
      session,
      dispatch,
      (response) => {
        // console.log('location response: -', response)
        callback({ success: 1, result: response.resource });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function fetchPurchaseTransaction(
  session,
  obj,
  transactiontype = "purchase",
  callback
) {
  var url = `${INSTANCE_URL}api/v2/tikwash_script`;
  var body = {
    session: session,
    transactiontype: transactiontype,
    type: "purchase_spent",
  };
  if (!_.isEmpty(obj)) {
    for (const [key, value] of Object.entries(obj)) {
      body[key] = value;
    }
  }
  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        dispatch({
          type: PURCHASE_TRANSACTION_LIST,
          payload: { data: response.result },
        });
        callback({ success: 1 });
      },
      (error) => {
        //callback({success: 0, message: error});
      }
    );
  };
}
export function emptyTransaction() {
  return (dispatch) => {
    dispatch({ type: PURCHASE_TRANSACTION_LIST, payload: {} });
  };
}

export function createMerchant(session, values, callback) {
  var url = `${INSTANCE_URL}api/v2/tikwash_script`;

  values.type = "createmerchant";
  return (dispatch) => {
    postRequest(
      url,
      values,
      session,
      dispatch,
      (response) => {
        // console.log('location response: -', response)
        callback({ success: 1, result: response.resource });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function downloadInvoice(
  session,
  transactionid,
  methodtobecall,
  callback,
  type = ""
) {
  var url = `${INSTANCE_URL}api/v2/${methodtobecall}`;
  var body = {
    transactionid: transactionid,
  };
  if (type != "") {
    body.transactioncode = type;
  }
  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        if (
          response.resource &&
          response.resource.length > 0 &&
          response.resource[0].path
        ) {
          callback({ success: 1, filename: response.resource[0].path });
        } else {
          callback({ success: 0 });
        }
      },
      (error) => {
        //callback({success: 0, message: error});
      }
    );
  };
}
